<template>
  <v-select
    :label="label"
    :outlined="outlined"
    :items="items"
    item-text="name"
    item-value="name"
    v-model="selectedBrand"
    @change="onChange"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { BRANDS_QUERY } from "../../../constants/graphql";
const sortBrandsByName = (brandA, brandB) => {
  return brandA.name > brandB.name ? 1 : -1;
};
export default {
  name: "brand-list-select",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    label: {
      type: String,
      default: () => "Brand",
    },
  },

  data() {
    return {
      debug: false,
      selectedBrand: this.value ? this.value : "",
    };
  },
  computed: {
    items() {
      return this.brands && this.brands.edges
        ? this.brands.edges.map(removeGQLTypename).sort(sortBrandsByName)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.selectedBrand = newVal;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedBrand);
    },
  },

  apollo: {
    brands: {
      query: BRANDS_QUERY,
      variables() {
        return {
          filter: {
            not_in_use_eq: false,
          },
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/BrandListSelect.vue